(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    if (!window.stellaTermsConsent) {
    window.stellaTermsConsent = true;

    const showError = (box) => {
      const error = document.getElementById('cart-terms-consent-error');
      if (error) error.hidden = false;
      box.focus();
    };

    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('.cart__checkout-button');
        const box = document.querySelector('.cart-consent__input');
        if (!button || !box || box.checked) return;
        event.preventDefault();
        event.stopPropagation();
        showError(box);
      },
      true
    );

    document.addEventListener(
      'submit',
      (event) => {
        const box = document.querySelector('.cart-consent__input');
        if (!box || box.checked || event.submitter?.name !== 'checkout') return;
        event.preventDefault();
        event.stopPropagation();
        showError(box);
      },
      true
    );

    document.addEventListener('change', (event) => {
      if (!event.target.matches('.cart-consent__input')) return;
      const error = document.getElementById('cart-terms-consent-error');
      if (error) error.hidden = event.target.checked;
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["language-toggle"] && !Shopify.designMode) return;
  try {
    class LanguageSelector extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.list = this.querySelector('.language-selector__list');
      if (!this.details) return;

      this.details.addEventListener('toggle', () => {
        if (this.details.open) this.keepOnScreen();
      });
      document.addEventListener('click', (event) => {
        if (this.details.open && !this.contains(event.target)) this.details.open = false;
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.details.open) {
          this.details.open = false;
          this.querySelector('summary').focus();
        }
      });
    }

    /* The selector can sit at either edge of the header depending on the page direction: flip the menu if it overflows */
    keepOnScreen() {
      this.list.style.insetInlineStart = '';
      this.list.style.insetInlineEnd = '';
      this.list.style.left = '';
      this.list.style.right = '';
      const rect = this.list.getBoundingClientRect();
      const margin = 8;
      if (rect.left < margin) {
        this.list.style.insetInlineStart = 'auto';
        this.list.style.insetInlineEnd = 'auto';
        this.list.style.right = 'auto';
        this.list.style.left = '0';
      } else if (rect.right > window.innerWidth - margin) {
        this.list.style.insetInlineStart = 'auto';
        this.list.style.insetInlineEnd = 'auto';
        this.list.style.left = 'auto';
        this.list.style.right = '0';
      }
    }
  }

  if (!customElements.get('language-selector')) {
    customElements.define('language-selector', LanguageSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
